export { Analytics as VercelAnalytics } from '@vercel/analytics/react';
